import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SbEditorToolsComponent } from './sb-editor-tools.component';
import { AvailabilityModule } from '../sb-editor-tools/availability/availability.module';
import { FiltersModule } from '../sb-editor-tools/filters/filters.module';
import { MultivenueModule } from '../sb-editor-tools/multivenue/multivenue.module';
import { SearcherModule } from '../sb-editor-tools/searcher/searcher.module';
import { AvailabilityComponent } from './availability/availability.component';
import { SearcherComponent } from './searcher/searcher.component';
import { MultivenueComponent } from './multivenue/multivenue.component';
import { FiltersComponent } from './filters/filters.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { VipinfoModule } from './vipinfo/vipinfo.module';
import { VipinfoComponent } from './vipinfo/vipinfo.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { DisclaimerModule } from './disclaimer/disclaimer.module';
import { LanguageModule } from './language/language.module';

@NgModule({
  declarations: [SbEditorToolsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FiltersModule,
    MultivenueModule,
    SearcherModule,
    AvailabilityModule,
    ColorPickerModule,
    VipinfoModule,
    DisclaimerModule,
    LanguageModule
  ],
  providers: [],
  exports: [
    SbEditorToolsComponent,
    SearcherComponent,
    AvailabilityComponent,
    MultivenueComponent,
    FiltersComponent,
    VipinfoComponent,
    DisclaimerComponent,
    LanguageModule
  ],
})
export class SbEditorToolsModule {}
